import { useQuery } from "@apollo/client";
import {GET_EVENTS} from "../../server/graphql/queries";
import Loading from "../../components/Loading";
import {classNames, fixUrl} from "../../helpers";
import typography from "../../helpers/typography";
import {Link} from "react-router-dom";
import {format} from "date-fns";
import { EyeIcon, UsersIcon } from "@heroicons/react/24/outline";

const Events = () => {
  const { loading, error, data } = useQuery(GET_EVENTS);
  const events = data?.events || [];

  if (loading) {
    return <Loading loading={loading} />;
  } else if (error) {
    throw new Error("Could not fetch events");
  }

  if (events.length === 0) {
    return (
      <div className="text-center m-4 text-zinc-500">
        <h5 className="text-lg mb-2">There are no events at this time</h5>
        <p>Visit us <a href="https://ccing.org" target="_blank" className="text-artfulRed hover:underline">here</a> to know what we are up to</p>
      </div>
    );
  }

  return (
    <div className="2xl:container 2xl:mx-auto my-4 px-4 sm:px-6 lg:px-8">
      <h2
        className={classNames(
          typography.sizes.h3,
          "font-poppins font-medium mb-5 text-gray-700"
        )}>
        Events
      </h2>

      <div className="mt-6 grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:gap-x-8">
        {events.map((event) => (
          <div key={event.uuid} className="group relative">
            <div className="min-h-80 sm:h-72 md:h-80 lg:h-80 aspect-w-1 aspect-h-1 w-full overflow-hidden rounded-md bg-gray-200 group-hover:opacity-75 lg:aspect-none">
              <img
                src={fixUrl(event.imageUrl)}
                alt={event.title}
                className="h-full w-full object-cover object-center lg:h-full lg:w-full"
              />
            </div>
            <div className="mt-4">
              <div>
                <h3 className="text-base lg:text-xl font-poppins font-medium text-gray-700">
                  <Link to={`/${event?.url ?? ""}`}>
                    <span aria-hidden="true" className="absolute inset-0" />
                    {event.title}
                  </Link>
                </h3>

                <div>
                  <p className="text-sm text-slate-500">{format(new Date(event.eventDate), 'yyyy-MM-dd')}</p>
                </div>

                <div className="mt-1 flex justify-between">
                  <p className="text-sm font-medium text-slate-500 flex"><EyeIcon className="stroke-slate-500 stroke-1 h-5 w-5 mr-1" /> {event.numberOfViews}</p>
                  <p className="text-sm font-medium text-slate-500 flex"><UsersIcon className="stroke-slate-500 stroke-1 h-5 w-5 mr-1" /> {event.numberOfDps}</p>
                </div>
              </div>
              <p className="text-sm font-medium text-gray-900" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Events;
